import request from "@common/request";
import { useMutation, useQuery, useQueryClient } from "react-query";

const useUserUpdate = () => {
  return useMutation((changes: { [key: string]: string | boolean }) =>
    request("PATCH", "/api/me", changes)
  );
};

const useUserDetailed = () => {
  return useQuery("me", () => request<Forme.UserDetailed>("GET", "/api/me"));
};

const useMfaReset = () => {
  return useMutation(() =>
    request<{ resetMfa: { url: string } }>("POST", "/api/me/reset-mfa")
  );
};

const useProfile = (options = {}) => {
  return useQuery(
    "profile",
    () => request<Forme.Profile>("GET", "/api/me/profile"),
    options
  );
};

const useProfileUpdate = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (
      data: Partial<
        Pick<Forme.Profile, "specialty" | "careerStage" | "npiNumber">
      >
    ) => request<Forme.Profile>("PATCH", "/api/me/profile", data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["currentClient"]);
      },
      ...options,
    }
  );
};

const useMeClient = (options = {}) => {
  return useQuery(
    "currentClient",
    () => request<Forme.ClientWithEmail>("GET", "/api/me/client"),
    options
  );
};

const useHouseholdClients = (options = {}) => {
  return useQuery(
    "householdClients",
    () => request<Forme.Client[]>("GET", "/api/me/household/clients"),
    options
  );
};

const useHouseholdAdvisors = (options = {}) => {
  return useQuery(
    "householdAdvisors",
    () => request<Forme.AdvisorWithRole[]>("GET", "/api/me/household/advisors"),
    options
  );
};

const useClientUpdate = (options = {}) => {
  // TODO: move this to mutations
  return useMutation(
    (changes: { [key: string]: string | boolean }) =>
      request("PATCH", "/api/me/client", changes),
    options
  );
};

const useHousehold = (options = {}) => {
  return useQuery(
    "household",
    () => request<Forme.HouseholdWithClientUsers>("GET", "/api/me/household"),
    options
  );
};

export {
  useClientUpdate,
  useHousehold,
  useHouseholdAdvisors,
  useHouseholdClients,
  useMeClient,
  useMfaReset,
  useProfile,
  useProfileUpdate,
  useUserDetailed,
  useUserUpdate,
};
